import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { useSearchParam, useTitle } from "react-use";
import * as yup from "yup";
import dueLogo from "../../assets/images/logo.svg";
import Button from "../../components/Button";
import { FormField } from "../../components/forms/shared";
import TextInput from "../../components/forms/TextInput";
import { ROUTE_LOGIN } from "../../routes";
import { resetPassword } from "../../services/user";

const validationSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required.")
    .min(8, "Password must be at least 8 characters long.")
    .max(30),
  confirmPassword: yup
    .string()
    .required("Password is required.")
    .min(8, "Password must be at least 8 characters long.")
    .max(30),
});

const ResetPassword = () => {
  useTitle("Reset Password | Due");
  const code = useSearchParam("code");
  const [disabled, setDisable] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  if (!code) {
    return <Redirect to={ROUTE_LOGIN} />;
  }

  const requestResetPassword = (password: string) => {
    setDisable(true);
    resetPassword(code, password).subscribe(
      () => {
        setMessage("New password has been set.");
      },
      () => {
        setDisable(false);
        setError("Failed to reset password please contact support.");
      }
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to={ROUTE_LOGIN}>
          <img className="mx-auto h-10 w-auto" src={dueLogo} alt="Due" />
        </Link>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Reset Password
        </h2>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <p className="text-sm mb-4">Enter a new secure password:</p>
          {message && (
            <div className="mb-4">
              <div className="text-sm text-gray-600">{message}</div>
              <Link
                to={ROUTE_LOGIN}
                className="text-sm text-green-600 font-semibold"
              >
                Return to login
              </Link>
            </div>
          )}
          {error && <div className="text-sm text-red-500 mb-4">{error}</div>}

          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}
            validate={({ password, confirmPassword }) => {
              console.log("here2");
              if (password !== confirmPassword) {
                return {
                  password: "Passwords do not match.",
                  confirmPassword: "Passwords do not match.",
                };
              }
              return {};
            }}
            initialValues={{
              password: "",
              confirmPassword: "",
            }}
            onSubmit={({ password }) => {
              console.log("here");
              requestResetPassword(password);
            }}
          >
            {({ values, errors, setFieldValue }) => {
              return (
                <Form>
                  <FormField
                    id="password"
                    label="Password"
                    error={errors.password}
                  >
                    <TextInput
                      id="password"
                      type="password"
                      name="password"
                      value={values.password}
                      onChange={(e) => {
                        setFieldValue("password", e.target.value);
                      }}
                      disabled={disabled}
                    />
                  </FormField>
                  <FormField
                    id="confirmPassword"
                    label="Confirm Password"
                    error={errors.confirmPassword}
                  >
                    <TextInput
                      id="confirmPassword"
                      type="password"
                      name="confirmPassword"
                      value={values.confirmPassword}
                      onChange={(e) => {
                        setFieldValue("confirmPassword", e.target.value);
                      }}
                      disabled={disabled}
                    />
                  </FormField>
                  <Button disabled={disabled}>Reset Password</Button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
